import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { LicenseBanner } from '../LicenseBanner';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard':     '',
  '/equipment':     'Equipment Registry',
  '/parts':         'Spare Parts',
  '/schedules':     'Maintenance Schedules',
  '/work-orders':   'Work Orders',
  '/history':       'Maintenance History',
  '/users':         'User Management',
  '/audit':         'Audit Log',
  '/notifications': 'Notifications',
};

export function AppShell() {
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] ?? 'VantixMT';
  const [menuOpen, setMenuOpen] = React.useState(false);

  // Close menu whenever the route changes
  React.useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-canvas-bg">
      {/* Backdrop — mobile only, sits below topbar */}
      {menuOpen && (
        <div
          className="fixed top-14 inset-x-0 bottom-0 z-30 bg-black/45 sm:hidden"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <Sidebar isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar
          title={title}
          isMenuOpen={menuOpen}
          onMenuToggle={() => setMenuOpen(m => !m)}
        />
        <LicenseBanner />
        <main className="flex-1 overflow-y-auto p-3 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
